import validate from "/home/node/app/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@22.13.9_db0@0.3.1_eslint@9.21.0_jiti@2.4._a52a08763c51121e4dcdb6b75b8390b1/node_modules/nuxt/dist/pages/runtime/validate.js";
import amazon_45route_45global from "/home/node/app/rdp-eyebot/middleware/amazon-route.global.ts";
import check_45redeemed_45global from "/home/node/app/rdp-eyebot/middleware/check-redeemed.global.ts";
import lens_45step_45global from "/home/node/app/rdp-eyebot/middleware/lens-step.global.ts";
import ui_45state_45global from "/home/node/app/rdp-eyebot/middleware/ui-state.global.ts";
import manifest_45route_45rule from "/home/node/app/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@22.13.9_db0@0.3.1_eslint@9.21.0_jiti@2.4._a52a08763c51121e4dcdb6b75b8390b1/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  amazon_45route_45global,
  check_45redeemed_45global,
  lens_45step_45global,
  ui_45state_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}